import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-363de26e"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ol", {
  class: "draw-hint"
}, [/*#__PURE__*/_createElementVNode("li", {
  class: "hint-content"
}, "请输入报名时填写的手机号，才能进行抽签")], -1));

const _hoisted_2 = {
  class: "dialog-footer"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 开始抽签 ");

import BallotAnimate from './BallotAnimate.vue';
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    liveId: String
  },
  emits: ['update:show', 'ballotResult'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      trainSignBallot
    } = inject('$http');
    const showAnimate = ref(false);
    const form = reactive({
      phone: ''
    });
    const applyFormRef = ref();
    const rules = {
      phone: [{
        required: true,
        pattern: /^[1][0-9]{10}$/,
        message: '请输入正确手机号',
        trigger: 'blur'
      }]
    };

    const handleClose = () => {
      emit('update:show', false);
    }; // 抽签


    const handleBallot = async () => {
      applyFormRef.value.validate(async valid => {
        if (valid) {
          const data = await trainSignBallot({
            liveId: props.liveId,
            phoneNumber: form.phone
          });
          handleClose();
          showAnimate.value = true;
          setTimeout(() => {
            showAnimate.value = false;
            emit('ballotResult', data);
          }, 2500);
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(show) ? show.value = $event : null),
        title: "参与报名抽签",
        width: "400px",
        "append-to-body": true,
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          class: "btn",
          size: "large",
          type: "primary",
          disabled: !_unref(form).phone,
          onClick: handleBallot
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          ref_key: "applyFormRef",
          ref: applyFormRef,
          rules: rules,
          "label-position": "top",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).phone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).phone = $event),
              size: "large",
              placeholder: "请输入手机号",
              maxlength: "11"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _hoisted_1]),
        _: 1
      }, 8, ["modelValue"]), showAnimate.value ? (_openBlock(), _createBlock(BallotAnimate, {
        key: 0
      })) : _createCommentVNode("", true)], 64);
    };
  }

};